import { Route, Routes } from 'react-router-dom';
import { CustomerPanelLayout } from './CustomerPanelLayout';
import Login from './components/Login';
import SaleOrderList from './components/SaleOrderList';
import SaleOrderDetail from './components/SaleOrderDetail';

const CustomerPanelPage = () => (
  <Routes>
    <Route element={<CustomerPanelLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='sale-order' element={<SaleOrderList />} />
      <Route path='sale-order-detail' element={<SaleOrderDetail />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
);

export { CustomerPanelPage };

// export default CustomerPanelPage
